var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"clearable":"","value":_vm.value,"placeholder":"请选择组织"},on:{"change":_vm.selOptionChange}},_vm._l((_vm.orgList),function(item){return _c('el-option',{key:item.partnershipId,attrs:{"label":item.partnerName,"value":item.partnershipId}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99797af4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BelongOrgSelect/index.vue
// module id = null
// module chunks = 